module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2r"
  }, [_c('a', {
    attrs: {
      "id": "ch02"
    }
  }), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('span', {
    staticClass: "txbdhc"
  }, [_c('span', {
    staticClass: "bcolor"
  }, [_vm._v("2")])])])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('h2', {
    staticClass: "h2al"
  }, [_c('span', {
    staticClass: "txbdmc"
  }, [_c('span', {
    staticClass: "txitmc"
  }, [_vm._v("Reel TV")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_c('span', {
    staticClass: "fontp"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "txbdh1p"
  }, [_vm._v("liens?” I wasn’t sure")]), _vm._v(" I’d heard right.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“As in people from other countries?” George suggested.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Joel jumped right in. “Nope.” He looked gleeful. “More like creatures from another "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("planet")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“As in UFOs?” George looked dubious.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“As in UFOs,” Winnie repeated, sounding a little flat. For some reason she didn’t seem to share Joel’s enthusiasm for their extraterrestrial visitors.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Right!” Bess caught my eye. Her expression mirrored my own skepticism. “Aliens, like in the movies.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I waited for Winnie to start laughing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She didn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re kidding, right?” This had to be some kind of joke.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("She shook her head. “It isn’t. Not that "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("I’m")]), _vm._v(" convinced they’re real,” she added quickly. “But lots of people are buying into it.” She motioned out the window. A white van with a national cable network logo was stopped at the light. It sported a satellite antenna on top.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“The media sure "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("hope")]), _vm._v(" the UFOs are the real deal,” Joel pointed out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Just then, someone called from the kitchen. “Scarletti, get in here. . . . Something’s weird with this sauce.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Duty calls. Be right there,” Joel shouted back. “See you guys,” he said, as he disappeared into the back of the restaurant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Winnie let out a tired sigh. “And "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("that’s")]), _vm._v(" the problem. . . . Everyone is so distracted and excited by all the craziness—TV crews, crowds, reporters—they’re making mistakes.” She gave a meaningful glance to Mary Beth, the waiter, who was still setting up for dinner. “My waiters are constantly poking their heads outside to check the sky for spaceships. The one saving grace is that the customers are equally distracted. But in the long run I’m wondering if these UFOs are going to hurt the dinner trade.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The aliens turn up at dinnertime?” George said with a straight face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Winnie cracked a smile. “Seems that way. They favor nighttime. Though I recall there was at least one daytime sighting.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("Why mainly at night? I wondered, as George spoke up. “Looks to me like your visitors from outer space have put Brody’s Junction on the map.”")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“UFOs in Vermont?” Bess started to giggle. “It’s too much. Little green men, deciding to land in the Green Mountain State!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe they’re little red men wearing green snowsuits,” George suggested.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Martian fashionistas!” I laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Laugh if you want,” Mary Beth said, looking up from behind the counter. She had picked up a fresh supply of napkins. The real fear in her voice wiped the smile right off my face. “But the state police, the sheriff, the mayor, and the crew of a reality TV show are taking them seriously. Even the FBI has sent investigators.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The FBI?” Maybe this "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("was")]), _vm._v(" a bigger deal than we were making it out to be.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, even the FBI,” Winnie said, then turned to give some instructions to Mary Beth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The possibility of UFOs and all the publicity surrounding sightings explained away the mystery of the traffic and the increased police presence in the small town. “How come it’s not on the national news?” I asked.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("Winnie shrugged. “The first sightings didn’t cause much of a stir. Most folks around here thought the kids reporting seeing UFOs on a Friday night had")]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v(" either been partying too hard or were playing pranks. Even when they had pictures.”")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“There are "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("pictures")]), _vm._v("?” Bess looked interested.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Computer generated,” George predicted. “Altered through a photo program.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No one’s been able to tell either way, though the FBI took the photos with them for forensic studies.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Which proved what?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nothing yet,” Winnie answered. “Or at least no one is talking about what they might have found. But there are experts from NASA in town, plus all this press—which leads me to think they probably turned up something. The national media will be broadcasting this news this weekend, for sure. Joel tells me the latest local blogs are full of the reports. I’m surprised you didn’t come across them, George,” Winnie said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("George’s reputation as a technophile preceded her. She shrugged. “I saw some stuff, but didn’t bother to read it. Nuts are constantly reporting alien sightings online. I ignore them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is this the first time national TV networks have bothered to send reporters?” I asked, looking out the window as the cable network’s van made a left at the corner. Watching it made my spirits sink. Who wanted to spend a vacation in the middle of some crazy media circus? Then again . . . there could be a real mystery here.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Winnie nodded. “Makes it all seem more real.”")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("George turned toward Winnie. “Tell me, you don’t really believe in UFOs, do you? Have you ever seen them yourself?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes,” Winnie said. “Twice. But,” she added pointedly, “that doesn’t mean they’re the real thing. Half the troopers are convinced they’re hoaxes. But once the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Reel TV")]), _vm._v(" crew airs its footage next week, half the UFO fanatics in the country are going to invade this town big-time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I had watched "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Reel TV")]), _vm._v("’s reality show once or twice. Personally I couldn’t believe anyone was taken in by their investigations of paranormal situations. “So that explains all the ‘No Vacancy’ signs on the motels and inns on the way here,” I remarked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I wish I’d bothered to read the online reports. Maybe I will now.” George walked over to Winnie’s laptop open on the counter. “Can I log on now? My computer’s still back in the car.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You can’t. My system keeps crashing. Maybe you can find the problem. Everything’s affected: my e-mail, my address book, my website, and today I couldn’t even access any of my bookkeeping programs.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("George peeled off her down vest. “Maybe it’s a virus. Let me check it out.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Winnie stopped her. “Not now, George. I’ve got to get into the kitchen and deal with dinner, and you guys must want to settle in after your trip. My friend ")]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("Sarah Conway, the owner of Under Mountain Inn, called. She’s holding your room. Given the crush of tourists, you’d better check in now. You’ll like Sarah. She’ll make you feel right at home.”")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay,” George said. “I’ll run some diagnostics on your system after dinner, if you feel it can wait. We can catch up on family news then—Mom’s dying to know what’s new with you and the café.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Under Mountain Inn was all that Winnie had promised, and I was secretly pleased that she had lacked the room to put us up herself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The three-story white building had several gables with steeply sloped black slate roofs. Green shutters framed the windows. Several hearty souls were parked on wicker benches on the wraparound porch, watching the sun slide down behind the low hills to the west of town. In the fading afternoon light a single electric candle burned in every window, giving the establishment a cozy, welcoming look. An inscription over the front door said the original inn, parts of which were still standing, dated from 1801.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I couldn’t help but think that if the place hadn’t looked so well-kept and freshly painted, it would have been the perfect setting for a ghost story. Old-fashioned and creepy. Instead, though, it was modernized, refreshed—and beautiful.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("When we arrived, a woman was on the phone behind the reception desk. While we waited to register, I looked around. The lobby was spacious and welcoming. It flowed into a large, comfortable lounge generously furnished with an assortment of couches and overstuffed easy chairs. A cozy fire burned in the fireplace, and at the far end of the room an archway opened into a dining room.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("As soon as she hung up the phone, the woman introduced herself as Sarah Conway, the innkeeper. When we mentioned we were Winnie’s guests, she hurried out from behind the desk and warmly pumped our hands. “Winnie told me all about you girls.” Turning toward George, she said, “I know you from the pictures of you and your mom that Winnie has up in her apartment. One of you is Bess, and the other is Nancy—the amateur detective!” She looked from me to Bess and back at me again. “You’re Nancy, right? And you”—she looked at Bess—“must be Bess.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m impressed.” I laughed. “How did you know?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sarah blushed. “I’ve seen Bess’s picture too—after all, she’s George’s cousin, and there are photos from that family reunion a few years back.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("After calling for someone to cover the desk, Sarah personally escorted us to the third floor. She was open-faced and talkative, and seemed determined to ")]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("give us special treatment because we were Winnie’s friends. “I hate putting you all into such cramped quarters,” she apologized as she climbed the stairs ahead of us.")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Our room was at one end of the long hall. “At least you get a view of the mountain.” She unlocked the door. “I put you guys in the best room I could spare up here. The other two are rented out to the TV crew. They haven’t got the view.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("True to her word, the room was barely large enough for three twin beds and one rocking chair. A large old-fashioned wardrobe stood next to a dresser. Tieback curtains framed each of the two windows: One provided a view of the mountain, and the other opened onto a fire escape.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Winnie probably told you about the tourist invasion. Not that anyone in town is complaining,” Sarah told us.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("George looked up from rummaging in her duffle bag. “Mom had mentioned that Winnie was having second thoughts about refinancing the café because things were so slow. We were amazed to see everything booming.” While George talked, she stowed her computer and backpack on top of the wardrobe. She deposited her running gear onto the bed. Earlier she had announced we were all in dire need of a good run—particularly after sitting so long all day, ")]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("and with the prospect of a gourmet calorie-laden dinner facing us that evening.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("While we unpacked, Sarah continued to talk. “The UFO sightings took everyone by surprise. Most tradesmen and merchants are pretty happy about it. It’s hard for the restaurants to handle the crowds, though. Take Winnie’s place, for instance. It’s all too much to deal with on top of her other problems.” Abruptly she stopped and checked her watch. “But don’t get me started about Winnie and her life. Likely you’re more in the know than I am,” she said to George. “I’ve got to get downstairs, pronto. The TV crew pulled in just before you girls. The producer was pretty miffed they couldn’t have the whole place to themselves—offered me good money too, but I’m not going to turn down the few regulars I have this time of year to put those people up! The minute some hot new story breaks, they’ll drop the UFO angle and be gone. Fat lot of good that’ll do me next year.” With that, she hurried out the door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I waited until I heard her footsteps fade down the hall. “Is Winnie in some kind of trouble?” I asked George.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("“Other than slow business, nothing I’ve heard about.” As George changed into her sweats, she added, “Mom would have mentioned anything serious—I ")]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("think.” However, George appeared worried as she stuffed her duffle under the bed.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Bess tried to reassure George. “You’re right. If Winnie’s problems were superserious, your mom would have told you.” As she put on a vintage River Heights High letter jacket, she added, “More to the point, Winnie would have asked us to postpone this trip.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Bess is right,” I said. “Unless, of course, Winnie never told her something was wrong—or something cropped up after we left.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe Mom just didn’t feel free to share all of Winnie’s problems with me,” George said. “Whatever—I’m glad we’re here. Maybe we can help her out.” George put one foot up on the dresser and began doing her pre-workout stretches.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good thinking,” I added. “As soon as I’ve worked out and before we come back to change for dinner, I’m going to corner Sarah and find out what she didn’t tell us.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bess laughed. “That won’t take much prodding. She looked ready to burst out every detail . . . until she realized how late it was. Which reminds me, we’d better go running now, or we’ll be late for dinner.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Bess had a point. Frankly, I was ready to skip the run. Sarah’s comments had stirred my curiosity. It ")]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("sounded like Winnie was in trouble—and I was confused about why George had had no idea at all.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As we headed out for our run, we saw the inn’s staff gathering luggage from the reception area and carting it upstairs. Members of the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Reel TV")]), _vm._v(" crew—the name was on their jackets and sweatshirts—were sorting shiny metal film canisters and camera equipment. The crew milled around the front desk as Sarah registered the new arrivals.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She waved as we passed. “Have a good run,” she called out. She started to say something else, but a siren’s wail drowned out her next words.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sounds like a fire somewhere,” I said, hurrying over toward the porch. The door flew open in my face, and a dark-haired man stepped through the entrance, blocking my exit. He was only a little taller than me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He swept a shock of straight black hair back from his forehead, and he shouted, “Izzy, they’re back.” Without waiting for a response, he raced back out. I followed him. I watched from the porch steps as he tore over to a white van idling by the curb. He threw open the back doors.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Before I could see what he was unloading, Bess and George hurried out onto the porch. “What’s going on?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("“I’m not sure,” I answered. People were pouring ")]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("out of shops, restaurants, and houses, streaming toward the town square. “Maybe there’s a fire somewhere.”")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” Sarah cried. “Like he said, they’re back.” She grabbed my arm and half pulled me along with her. “Come on, girls,” she shouted to Bess and George. “If it’s anything like last time, you’ll get a better view from the square.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The town square was packed, and we were relegated to the back of the crowd. All heads were turned skyward. Sarah pointed toward the east over the mountain. Circles of light revolved slowly against the deepening blue sky. They hung, suspended, over the meadow for a moment. Then they swept the circumference of the field and hovered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The effect was hypnotic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This is totally unreal,” I murmured. It had to be a hoax. Right?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f5415ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02.vue
// module id = 81
// module chunks = 0